/**
 *  @shelf-version: 1.0.0
 */

import FocusTrap from './focus-trap'

export default FocusTrap
